<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <register-title class="form__title">{{
        $t("license info")
      }}</register-title>
      <!--------------------------------------------------------   SHORT NAME   ----->
      <register-input
        componentID="buss_activity_type"
        inputType="text"
        :label="$t('buss activity type')"
        :inputPlaceholder="$t('buss activity type')"
        :isRequired="true"
        v-model="form.business_activity_type"
        class="form__input"
      />
      <!--------------------------------------------------------   LICENSE    ----->
      <register-input
        componentID="license_number"
        inputType="text"
        :label="$t('license number')"
        :inputPlaceholder="$t('license number')"
        :isRequired="true"
        v-model="form.number"
        class="form__input"
      />
      <!--------------------------------------------------------   ISSUE DATE (START)    ----->
      <register-input
        v-model="form.issued_at"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        :label="$t('license issue date')"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   ISSUE DATE (END)    ----->
      <register-input
        v-model="form.valid_till"
        componentID="issue-date-end"
        inputType="date"
        :minDate="new Date()"
        :label="$t('license validity period')"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------  Issuer   ----->
      <register-input
        componentID="issuer"
        inputType="text"
        :label="$t('name of the issuing authority')"
        :inputPlaceholder="$t('name of the issuing authority')"
        :isRequired="true"
        v-model="form.issuer"
        class="form__input"
      />
      <!--      &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Address   -&#45;&#45;&ndash;&gt;-->
      <!--      <register-input-->
      <!--        componentID="address"-->
      <!--        inputType="text"-->
      <!--        label="Регистрационный адрес (страна, почтовый индекс, населенный пункт, улицы/район, номер здания"-->
      <!--        inputPlaceholder="Регистрационный адрес"-->
      <!--        :isRequired="true"-->
      <!--        v-model="form.address"-->
      <!--        class="form__input"-->
      <!--      />-->
      <!--      &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; fact_ Address   -&#45;&#45;&ndash;&gt;-->
      <!--      <register-input-->
      <!--        componentID="fact_address"-->
      <!--        inputType="text"-->
      <!--        label="Фактический адрес (страна, почтовый индекс, населенный пункт, улицы/район, номер здания"-->
      <!--        inputPlaceholder="Фактический адрес"-->
      <!--        :isRequired="true"-->
      <!--        v-model="form.fact_address"-->
      <!--        class="form__input"-->
      <!--      />-->
      <!--------------------------------------------------------   SHORT NAME   ----->
      <file-input
        :mini="true"
        :is_uploaded="form_files.license"
        v-model="form_files.license"
        @attached="saveFile(form_files.license, 'license')"
        class="form__input-container"
        componentID="doc_1"
      >
        {{ $t("le activity license") }}
      </file-input>
      <file-input
        :mini="true"
        :is_uploaded="form_files.legal_extract_security_register"
        v-model="form_files.legal_extract_security_register"
        @attached="
          saveFile(
            form_files.legal_extract_security_register,
            'legal_extract_security_register'
          )
        "
        class="form__input-container"
        componentID="doc_2"
      >
        {{ $t("holders register extract") }}
      </file-input>

      <file-input
        :mini="true"
        :is_uploaded="form_files.signatures_samples"
        v-model="form_files.signatures_samples"
        @attached="
          saveFile(form_files.signatures_samples, 'signatures_samples')
        "
        class="form__input-container"
        componentID="doc_3"
      >
        {{ $t("signatures notarized document") }}
      </file-input>
      <button class="button filled form__button">{{ $t("confirm") }}</button>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      form: {
        business_activity_type: null,
        number: null,
        issued_at: null,
        valid_till: null,
        issuer: null
      },
      form_files: {
        license: null,
        legal_extract_security_register: null,
        signatures_samples: null
      },
      form_dates: ["issued_at", "valid_till"]
    };
  },
  mixins: [regFormMixin],
  methods: {
    formatDocNumber() {
      this.form.document_number = this.form.document_number.replace(/\D/g, "");
      this.form.document_number = this.form.document_number.substr(0, 9);
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userLicense[0] || {}).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        Object.entries(this.form_files).map(obj => {
          let find_file = this.user_profile.userUploadedDocuments.find(
            file => file.type === obj[0]
          );
          this.form_files[obj[0]] = (find_file ? true : null) || null;
        });
        this.form_dates.forEach(date => {
          this.form[date] = this.dateFormat(this.form[date]);
        });
        // console.log(this.isKazDoc(this.form.document_type));
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    isFilesAdded() {
      return (
        this.form_files.license &&
        this.form_files.signatures_samples &&
        this.form_files.legal_extract_security_register
      );
    },
    nextStep() {
      this.$router.push({ name: "address-info" });
    },
    saveData() {
      let url = `profile/license`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (this.isFilesAdded()) {
        this.saveData();
      } else {
        this.$toasted.clear();
        this.$toasted.show(this.$t("attach files"));
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
